<template>
	<div>
		<button :class="buttonclass" v-bind="$attrs" v-on="$listeners">
			<slot />
		</button>
	</div>
</template>

<script>
export default {
	props: {
		buttonclass: {
			type: String,
			default: ""
		}
	}
};
</script>

<style scoped lang="scss">
@import "../../assets/css/variable.scss";
button {
	width: 100%;
	height: 100%;
}
button:disabled,
button[disabled] {
	color: lightgray;
}
.btn {
	border: 1px solid $orange-bg-button-color;
	background-color: $orange-bg-button-color;
	text-align: center;
	border-radius: 2px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
	color: #fff;
}
.btn:hover {
	// color: #fff;
	background: #fff;
	color: $orange-bg-button-color;
}
.btn-active {
	border: 1px solid $orange-bg-button-color;
	text-align: center;
	border-radius: 2px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
	background-color: #fff;
	color: $orange-bg-button-color;
}
.forecast-approved {
	border: 1px solid #51d88a;
	background: #51d88a;
	color: #fff;
}
.largefont {
	font-size: 30px;
}
.button {
	display: inline-flex;
	align-items: center;
	justify-content: space-between;
	height: 52px;
	padding: 0 40px;
	background: transparent;
	border: none;
	border-radius: 6px;
	text-align: center;
	font-weight: 600;
	white-space: nowrap;
	transition: all 0.2s linear;
}
.button:hover {
	-webkit-transform: scale(1.02);
	transform: scale(1.02);
	box-shadow: 0 7px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.button:active {
	-webkit-transform: scale(1);
	transform: scale(1);
	box-shadow: none;
}
.button:focus {
	outline: 0;
}
.button.-fill-gradient {
	background: linear-gradient(to right, #16c0b0, #84cf6a);
	color: #ffffff;
}
.button:disabled {
	-webkit-transform: scale(1);
	transform: scale(1);
	box-shadow: none;
	background: #eeeeee;
}
.button + .button {
	margin-left: 1em;
}
.button.-fill-gray {
	background: rgba(0, 0, 0, 0.5);
	color: #ffffff;
}
.button.-size-small {
	height: 32px;
}
.button.-icon-right {
	text-align: left;
	padding: 0 20px;
}
.button.-icon-right > .icon {
	margin-left: 10px;
}
.button.-icon-left {
	text-align: right;
	padding: 0 20px;
}
.button.-icon-left > .icon {
	margin-right: 10px;
}
.button.-icon-center {
	padding: 0 20px;
}
</style>
